<template>
  <div>
    <h1 class="title is-4">Edades</h1>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Nombre</label>
          <div class="control">
            <input
              v-model="edad.nombre"
              class="input"
              type="text"
              placeholder="Nombre"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Días</label>
          <div class="control">
            <input
              v-model="edad.dias"
              class="input"
              type="number"
              placeholder="Días"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Porcentaje</label>
          <div class="control">
            <input
              v-model="edad.porcentaje"
              class="input"
              type="number"
              placeholder="Porcentaje"
            />
          </div>
        </div>
      </div>
    </div>
    <button class="button is-primary" @click="save">Guardar</button>
    <button class="button is-light" @click="cancel">Cancelar</button>

    <hr />
    <table class="table">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Días</th>
          <th>Porcentaje</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in edades" :key="index">
          <td>{{ item.nombre }}</td>
          <td>{{ item.dias }}</td>
          <td>{{ item.porcentaje }}%</td>
          <td>
            <div class="buttons has-addons">
              <button class="button is-small" @click="edit(item)">
                <span class="icon is-small">
                  <span class="material-icons"> mode_edit </span>
                </span>
              </button>
              <button class="button is-small is-danger" @click="eliminar(item)">
                <span class="icon is-small">
                  <span class="material-icons"> delete_forever </span>
                </span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      edad: {
        _id: null,
        nombre: null,
        dias: null,
        porcentaje: null,
      },
      edades: [],
    };
  },
  computed: {
    ...mapState(["modalnotification"]),
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
  },
  methods: {
    async save() {
      try {
        if (!this.edad.nombre) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar un nombre",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.edad.dias) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar los días",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.edad.porcentaje) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar el porcentaje",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (this.edad._id) {
          await apiServices.post(`/editedades`, this.edad);
        } else {
          await apiServices.post(`/createedades`, this.edad);
        }
        this.edad = {
          _id: null,
          nombre: null,
          dias: null,
          porcentaje: null,
        };
        this.find();
      } catch (err) {
        console.log(err);
      }
    },
    async find() {
      try {
        const result = await apiServices.get(`/getedades`);
        if (result.data) {
          this.edades = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async edit(edad) {
      try {
        this.edad = JSON.parse(JSON.stringify(edad));
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
        console.log(err);
      }
    },
    cancel() {
      this.edad = {
        _id: null,
        nombre: null,
        dias: null,
        porcentaje: null,
      };
    },
    eliminar(edad) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "Atención!",
          message: "Realmente desea eliminar la configuración de edad?",
          clase: "is-warning",
          data: edad._id,
        },
      });
    },
    async deleteedad(idedad) {
      try {
        await apiServices.delete(`/deleteedad/${idedad}`);
        this.find();
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    resultnotification(nv, ov) {
      if (nv) {
        this.deleteedad(this.modalnotification.result.data);
      }
    },
  },
  created() {
    this.find();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/comisiones/Edades.vue